import { useContext } from "react";
import { ProgressTrackerSettingsContext } from "./ProgressTrackerSettings.context";

export const useProgressTrackerSettingsContext = () => {
    const context = useContext(ProgressTrackerSettingsContext);
    if (!context) {
        throw new Error('useProgressTrackerSettingsContext must be used within a ProgressTrackerSettingsProvider');
    }
    return context;
}